import { render, staticRenderFns } from "./customer_address_detail.vue?vue&type=template&id=8222f2e0&lang=pug"
import script from "./customer_address_detail.vue?vue&type=script&lang=js"
export * from "./customer_address_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports